import React, { useState, useEffect } from 'react';
import '../styles/ManufacturingFacility.css';

import QuoteModal from './QuoteModal';

import facilityMain from '../assets/a1.png';
import facilityQuality from '../assets/a2.png';
import facilityTech from '../assets/a3.png';
import facilityAssembly from '../assets/a4.png';

const ManufacturingFacility = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [fade, setFade] = useState(true);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  /* ============================================
     FACILITY IMAGES
  ============================================ */

  const facilityImages = [
    {
      id: 1,
      image: facilityMain,
      title: 'Main Production Floor',
      desc: 'State-of-the-art assembly line'
    },
    {
      id: 2,
      image: facilityQuality,
      title: 'Quality Control Lab',
      desc: 'Rigorous testing procedures'
    },
    {
      id: 3,
      image: facilityTech,
      title: 'Technology Center',
      desc: 'Advanced equipment & machinery'
    },
    {
      id: 4,
      image: facilityAssembly,
      title: 'Assembly Unit',
      desc: 'Precision manufacturing'
    }
  ];

  /* ============================================
     AUTO SLIDER
  ============================================ */

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setActiveImage(
          (prev) => (prev + 1) % facilityImages.length
        );

        setFade(true);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, [facilityImages.length]);

  const handleThumbnailClick = (index) => {
    setFade(false);

    setTimeout(() => {
      setActiveImage(index);
      setFade(true);
    }, 200);
  };

  /* ============================================
     FACILITY STATS
  ============================================ */

  const stats = [
    {
      number: '25,000+',
      label: 'Annual Production Capacity',
      icon: 'fa-solid fa-industry'
    },
    {
      number: '100%',
      label: 'Quality Tested',
      icon: 'fa-solid fa-circle-check'
    },
    {
      number: 'Highly Skilled',
      label: 'Our Skilled Technicians',
      icon: 'fa-solid fa-users-gear'
    }
  ];

  /* ============================================
     QUALITY PROCESS
  ============================================ */

  const qualityProcess = [
    {
      step: '01',
      title: 'Raw Material Inspection',
      description: 'All components tested before assembly',
      icon: 'fa-solid fa-microscope'
    },
    {
      step: '02',
      title: 'In-Process Quality Check',
      description: 'Multi-point checks during assembly',
      icon: 'fa-solid fa-list-check'
    },
    {
      step: '03',
      title: 'Final Product Testing',
      description: '100% functional testing before packaging',
      icon: 'fa-solid fa-chart-column'
    },
    {
      step: '04',
      title: 'Batch Sampling',
      description: 'Random samples tested for durability',
      icon: 'fa-solid fa-clipboard-check'
    },
    {
      step: '05',
      title: 'Packaging Verification',
      description: 'Packaging integrity and seal check',
      icon: 'fa-solid fa-box'
    },
    {
      step: '06',
      title: 'Dispatch Clearance',
      description: 'Final QA sign-off before shipping',
      icon: 'fa-solid fa-truck-fast'
    }
  ];

  /* ============================================
     TECHNOLOGY
  ============================================ */

  const technologies = [
    {
      name: 'Digital Testing Equipment',
      description: 'Advanced acoustic measurement tools',
      icon: 'fa-solid fa-wave-square'
    },
    {
      name: 'Automated Calibration Systems',
      description: 'Precision calibration for every unit',
      icon: 'fa-solid fa-sliders'
    },
    {
      name: 'Quality Management Software',
      description: 'Real-time quality tracking',
      icon: 'fa-solid fa-laptop-code'
    }
  ];

  return (
    <>
      <section
        id="manufacturing-facility"
        className="manufacturing-facility-section"
      >
        <div className="manufacturing-facility-container">

          {/* =====================================
              SECTION HEADER
          ====================================== */}

          <div className="manufacturing-facility-header">

            <span className="manufacturing-facility-tagline">
              Our Infrastructure
            </span>

            <h2 className="manufacturing-facility-title">
              State-of-the-Art{' '}
              <span className="manufacturing-facility-highlight">
                Manufacturing Facility
              </span>
            </h2>

            <div className="manufacturing-facility-underline"></div>

            <p className="manufacturing-facility-subtitle">
              Located in Kolkata's Ecospace Business Park, our facility
              combines cutting-edge technology with skilled craftsmanship
              to deliver world-class hearing aids.
            </p>

          </div>


          {/* =====================================
              FACILITY STATS
          ====================================== */}

          <div className="manufacturing-facility-stats">

            {stats.map((stat, index) => (

              <div
                key={index}
                className="manufacturing-facility-stat-card"
              >

                <div className="manufacturing-facility-stat-icon">
                  <i
                    className={stat.icon}
                    aria-hidden="true"
                  ></i>
                </div>

                <div>
                  <span className="manufacturing-facility-stat-number">
                    {stat.number}
                  </span>

                  <span className="manufacturing-facility-stat-label">
                    {stat.label}
                  </span>
                </div>

              </div>

            ))}

          </div>


          {/* =====================================
              FACILITY GALLERY

              Currently hidden intentionally.
              Remove comments if you want gallery.
          ====================================== */}

          {/*
          <div className="manufacturing-facility-gallery">

            <div className="manufacturing-facility-main-image">

              <div
                className={`manufacturing-facility-image-wrapper ${
                  fade ? 'fade-in' : 'fade-out'
                }`}
              >
                <img
                  src={facilityImages[activeImage].image}
                  alt={facilityImages[activeImage].title}
                />
              </div>

              <div className="manufacturing-facility-image-caption">

                <h4>
                  {facilityImages[activeImage].title}
                </h4>

                <p>
                  {facilityImages[activeImage].desc}
                </p>

              </div>


              <div className="manufacturing-facility-slide-indicators">

                {facilityImages.map((_, index) => (

                  <button
                    type="button"
                    key={index}
                    className={`manufacturing-facility-indicator ${
                      activeImage === index ? 'active' : ''
                    }`}
                    onClick={() =>
                      handleThumbnailClick(index)
                    }
                    aria-label={`Go to slide ${index + 1}`}
                  />

                ))}

              </div>

            </div>


            <div className="manufacturing-facility-thumbnails">

              {facilityImages.map((img, index) => (

                <button
                  type="button"
                  key={img.id}
                  className={`manufacturing-facility-thumbnail ${
                    activeImage === index ? 'active' : ''
                  }`}
                  onClick={() =>
                    handleThumbnailClick(index)
                  }
                >

                  <img
                    src={img.image}
                    alt={img.title}
                  />

                  <div className="manufacturing-facility-thumbnail-overlay">
                    <span>
                      {img.title}
                    </span>
                  </div>

                </button>

              ))}

            </div>

          </div>
          */}


          {/* =====================================
              QUALITY CONTROL PROCESS
          ====================================== */}

          <div className="manufacturing-facility-quality">

            <div className="manufacturing-facility-quality-header">

              <h3>
                Quality Control Process
              </h3>

              <p>
                6-step rigorous testing ensures every product meets
                international standards
              </p>

            </div>


            <div className="manufacturing-facility-quality-grid">

              {qualityProcess.map((process, index) => (

                <div
                  key={index}
                  className="manufacturing-facility-quality-item"
                >

                  <div className="manufacturing-facility-quality-number">
                    {process.step}
                  </div>

                  <div className="manufacturing-facility-quality-icon">
                    <i
                      className={process.icon}
                      aria-hidden="true"
                    ></i>
                  </div>

                  <div className="manufacturing-facility-quality-content">

                    <h4>
                      {process.title}
                    </h4>

                    <p>
                      {process.description}
                    </p>

                  </div>

                </div>

              ))}

            </div>

          </div>


          {/* =====================================
              TECHNOLOGY & EQUIPMENT
          ====================================== */}

          <div className="manufacturing-facility-tech">

            <div className="manufacturing-facility-tech-header">

              <h3>
                Technology & Equipment
              </h3>

              <p>
                Powered by advanced machinery and cutting-edge technology
              </p>

            </div>


            <div className="manufacturing-facility-tech-grid">

              {technologies.map((tech, index) => (

                <div
                  key={index}
                  className="manufacturing-facility-tech-card"
                >

                  <div className="manufacturing-facility-tech-icon">

                    <i
                      className={tech.icon}
                      aria-hidden="true"
                    ></i>

                  </div>


                  <div>

                    <h4>
                      {tech.name}
                    </h4>

                    <p>
                      {tech.description}
                    </p>

                  </div>

                </div>

              ))}

            </div>

          </div>


          {/* =====================================
              FACILITY ADDRESS
          ====================================== */}

          <div className="manufacturing-facility-address">

            <div className="manufacturing-facility-address-icon">

              <i
                className="fa-solid fa-location-dot"
                aria-hidden="true"
              ></i>

            </div>


            <div className="manufacturing-facility-address-content">

              <h3>
                Visit Our Facility
              </h3>

              <p>
                Ecospace Business Towers, Tower 5A, Office no. 508,
                5th Floor, New Town, Kolkata - 700160
              </p>


              <button
                type="button"
                onClick={openQuoteModal}
                className="manufacturing-facility-address-btn"
              >
                Schedule a Visit

                <svg
                  className="manufacturing-facility-address-icon-btn"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M5 12H19M19 12L13 6M19 12L13 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

              </button>

            </div>

          </div>

        </div>
      </section>


      {/* ============================================
          QUOTE MODAL
      ============================================ */}

      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={closeQuoteModal}
      />
    </>
  );
};

export default ManufacturingFacility;